import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const NavBar = ({ className }) => {
    const navs = window.cccisd?.appDefs?.navs || [];
    const primaryNav = navs.find(nav => nav.handle === 'header');

    const role = window.cccisd.fortress.user.acting.role.handle;
    if (navs && primaryNav && (role === 'careCoordinator' || role === 'supervisor')) {
        const { administerPageAccess, dashboardPageAccess, managePageAccess } =
            window.cccisd.fortress.user.acting.role_data;

        const tabAccess = {
            Administer: administerPageAccess,
            Dashboard: dashboardPageAccess,
            Manage: managePageAccess,
        };

        primaryNav.nav = primaryNav.nav.filter(tab => {
            const access = tabAccess[tab.label];
            return access === undefined || access === null || !!access;
        });

        const mainNav = navs.find(nav => nav.handle === 'mainNav');
        if (mainNav && primaryNav.nav.length > 0) {
            mainNav.homepage = primaryNav.nav[0].url.replace('/', '');
        }
    }

    return (
        <Header
            containerClassName={className}
            wrapperClassName={style.wrapper}
            logoClassName={style.logo}
            showAlertAction={false}
            showHomeAction={false}
            primaryNavLinks={primaryNav?.nav || []}
            isDarkPrimaryNav
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
